import { BreadcrumbRouterLink } from '@/components/link/Link';
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator
} from '@/components/ui/breadcrumb';
import { ROUTES } from '@/constants';

type CalibrationTaskBreadcrumbsProps = {
	measurementGroupId: string | undefined;
};

const CalibrationTaskBreadcrumbs = (props: CalibrationTaskBreadcrumbsProps) => {
	const { measurementGroupId } = props;
	return (
		<Breadcrumb>
			<BreadcrumbList>
				<BreadcrumbItem>
					<BreadcrumbRouterLink to={ROUTES.home}>Home</BreadcrumbRouterLink>
				</BreadcrumbItem>
				<BreadcrumbSeparator />
				<BreadcrumbItem>
					<BreadcrumbRouterLink to={ROUTES.measurementGroups}>Measurement groups</BreadcrumbRouterLink>
				</BreadcrumbItem>
				<BreadcrumbSeparator />
				<BreadcrumbItem>
					<BreadcrumbRouterLink to={ROUTES.getMeasurementGroupURL(measurementGroupId)}>
						{measurementGroupId}
					</BreadcrumbRouterLink>
				</BreadcrumbItem>
				<BreadcrumbSeparator />
				<BreadcrumbItem>
					<BreadcrumbPage>Calibration operations</BreadcrumbPage>
				</BreadcrumbItem>
			</BreadcrumbList>
		</Breadcrumb>
	);
};

export default CalibrationTaskBreadcrumbs;
